import { render, staticRenderFns } from "./StudentSummaryByDate.vue?vue&type=template&id=2c4e7854"
import script from "./StudentSummaryByDate.vue?vue&type=script&lang=js"
export * from "./StudentSummaryByDate.vue?vue&type=script&lang=js"
import style0 from "./StudentSummaryByDate.vue?vue&type=style&index=0&id=2c4e7854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports